import React, { PropTypes } from 'react';

const Headline = (props) => {
    return (
              <div className="headline">
                <h1>Lead a more positive and balanced life</h1>
                <h2>
                  I teach clients how to identify and change distorted
                  thought patterns so they can lead better more enjoyable lives
                </h2>
              </div>
    );
};

export default Headline;



/** WEBPACK FOOTER **
 ** ./src/components/LandingPage/Hero/Headline.js
 **/